import axiosClient from "./axiosClient";
import { unwrapApiResponse } from "../utils/apiResponse";

export const submitCase = async (payload) => {
  const formData = new FormData();
  formData.append("subject", payload.subject);
  formData.append("description", payload.description);
  formData.append("category", payload.category);
  formData.append("institution", payload.institution);
  formData.append("location", payload.location);
  if (payload.date) formData.append("date", payload.date);
  formData.append("fullName", payload.fullName);
  formData.append("nationalId", payload.nationalId);
  formData.append("email", payload.email);
  if (payload.phone) formData.append("phone", payload.phone);
  formData.append("confirmed", payload.confirmed ? "true" : "false");

  (payload.files || []).forEach((file) => {
    formData.append("files", file);
  });

  const response = await axiosClient.post("/api/cases", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return unwrapApiResponse(response);
};

export const getCaseById = async (caseId, language = "en") => {
  const lang = (language || "en").toLowerCase();
  const response = await axiosClient.get(`/api/cases/${encodeURIComponent(caseId)}`, {
    params: { language: lang },
    headers: {
      "Accept-Language": lang,
      "X-Language": lang,
    },
  });
  return unwrapApiResponse(response);
};

export const getAdminCases = async ({
  page = 1,
  pageSize = 50,
  status,
  search,
} = {}) => {
  const response = await axiosClient.get("/api/admin/cases", {
    params: {
      page,
      pageSize,
      ...(status ? { status } : {}),
      ...(search ? { search } : {}),
    },
  });
  return unwrapApiResponse(response);
};

export const getAdminCaseById = async (id) => {
  const response = await axiosClient.get(`/api/admin/cases/${id}`);
  return unwrapApiResponse(response);
};

export const updateCaseStatus = async (id, payload) => {
  const response = await axiosClient.put(`/api/admin/cases/${id}/status`, payload);
  return unwrapApiResponse(response);
};

export const deleteCase = async (id) => {
  const response = await axiosClient.delete(`/api/admin/cases/${id}`);
  return unwrapApiResponse(response);
};
